const fromCents = (amount: number) => Number((amount / 100).toFixed(2));
const toCents = (amount: number) => Number((amount * 100).toFixed());

export { fromCents, toCents };
